module.exports = __webpack_public_path__ + "img/replacement.8e0419f5.svg";